<template>
  <div class="bills-card-box">
      <div class="bills-card">
        <div class="title">
           <div class="title-shop">
               <div>{{ billInfo.date }}</div>
               <div v-show="billInfo.payment === '5'">已结清</div>
           </div>
        </div>
        <div class="show-details-pay">
            <div class="details" @click = "handleClick">
                <div class="row">结款白单：{{ billInfo.orderAmount }} 张</div>
                <div class="row" v-if="billInfo.payment === '3'">未结金额：{{ billInfo.payable }} 元</div>
                <div class="row" v-if="billInfo.payment === '5'">已结金额：{{ billInfo.payable }} 元</div>
            </div>
            <div class="button-group" v-show="billInfo.payment === '3'">
                <div class="button-pay" @click="pay" v-show="!billInfo.isLoading">
                    <span>结清账单</span>
                </div>
                <div class="button-pay" @click="pay" v-show="billInfo.isLoading">
                    <van-loading color="#fff" size="23px" />
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>

export default {
name: 'BillsCard',
components: {
},
created(){

},
mounted(){
},
updated(){
},
data:()=>{
  return {
  }
},
methods:{
    handleClick(){
        this.$emit('goBillsDetailsPage', this.billInfo)
    },
    pay(){
        this.$emit('pay', this.billInfo)
    },
},
props:{
    billInfo:{
        type: Object,
        default: ()=>{}
    },
    tabId:{
        type: String,
        default: '0'
    },
    showButton:{
        type: Boolean,
        default: true
    },
    isLoading:{
        type: Boolean,
        default: false
    },
}
}
</script>

<style scoped lang="scss">
.bills-card-box {
  .bills-card {
      background: #fff;
      margin: 10px;
      border-radius: 20px;
      .title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 15px 20px 0;
          font-size: 15px;
          .title-shop {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              img {
                  border-radius: 2px;
                  margin: 0 5px;
              }
          }
          .count-down {
              display: flex;
              align-items: baseline;
              span {
                  margin-left: 5px;
              }
          }
          .status-paying {
              font-size: 15px;
              color: #f0061d;
          }
          .status-picking {
              font-size: 15px;
              color: #ffd700;
          }
          .status-cancel {
              font-size: 15px;
              color: #969699
          }
      }
  }
  .show-details-pay {
      text-align: left;
      background: #fff;
      // margin: 10px;
      border-radius: 15px;
      padding: 10px 20px 5px;
      font-size: 15px;
      .details {
          padding: 0 0 10px;
          margin: 5px 0 0;
          .row {
            margin: 10px 0;
            font-size: 16px;
          }
      }
      .pay-desc {
          padding: 5px 0 0;
          margin: 0 0 5px;
          .row {
              padding: 5px 0;
          }
      }
  }
  .button-group {
        padding: 5px 0 0;
        display: flex;
        justify-content: flex-end;
        border-top: 1px rgba(0,0,0,0.1) solid;
        .button-pay {
            position:relative;
            background: #29323c;
            border: 1px solid #29323c;
            border-radius: 25px;
            font-size: 15px;
            height: 32px;
            line-height: 32px;
            margin: 5px 10px;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100px;
            cursor: pointer;
        }
    }
}
</style>